import React from 'react'
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { NavLink } from 'react-router-dom'
import { AnimatedSection } from '../animations/MotionContainers'

export const AppShortcutCard = ({ title, description, icon, path, external }) => (
  <AnimatedSection>
    <Card className="app-shortcut-card">
      <CardActionArea
        component={external ? 'a' : NavLink}
        {...(external ? { href: path, target: '_blank', rel: 'noopener noreferrer' } : { to: path })}
        className="app-shortcut-action"
      >
        <CardContent className="app-shortcut-content">
          <Box className="app-shortcut-header">
            <Box className="app-shortcut-icon">{icon}</Box>
            <Typography className="app-shortcut-title">{title}</Typography>
          </Box>
          <Typography className="app-shortcut-description">{description}</Typography>
          <Box className="app-shortcut-footer">
            <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  </AnimatedSection>
)
